module.exports = __webpack_public_path__ + "img/Group 11.990a82fa.png";